import {Modal} from "antd";
import {OfferingFormPriceType} from "@/features/pricing";
import {PricingModelCardsFormField} from "../../../../general/pricing/pricing-model-cards";
import {
  ADD_ON_DISCARD_TITLE,
  addOnDiscardWarning,
  useProductAddOnGate,
} from "../../add-on-gate";

export {
  PWYW_CARD_TITLE,
  PWYW_CARD_DESCRIPTION,
} from "../../../../general/pricing/pricing-model-cards";

/**
 * The Digital Product's Pricing Model — the shared cards, plus the one thing only this
 * offering type can lose by switching.
 */
export function ProductSubPricingCostFormField() {
  const addOnGate = useProductAddOnGate();

  /**
   * The Pricing hierarchy rule where it costs the coach something.
   *
   * In the create wizard nothing has been built yet, so there is no gate and the switch
   * is silent. In edit, Add-ons may already exist — so the coach is told how many will go
   * and nothing moves until they say yes. Declining leaves both the Pricing Model and the
   * Add-ons exactly as they were.
   */
  async function confirmAddOnDiscard(to: OfferingFormPriceType): Promise<boolean> {
    if (to !== "pwyw" || addOnGate.addOnCount === 0) {
      return true;
    }

    return new Promise<boolean>((resolve) => {
      Modal.confirm({
        title: ADD_ON_DISCARD_TITLE,
        content: addOnDiscardWarning(addOnGate.addOnCount),
        okText: "Remove add-ons",
        okButtonProps: {danger: true},
        cancelText: "Cancel",
        onOk: async () => {
          await addOnGate.discardAddOns();
          resolve(true);
        },
        onCancel: () => resolve(false),
      });
    });
  }

  return <PricingModelCardsFormField confirmChange={confirmAddOnDiscard} />;
}
